<template>
  <v-container fluid v-if="this.$store.state.signedIn">
      <v-layout>
          <v-flex class="px-2 py-2">
              <v-card color='success' v-if="querySelect=='Events'">
                  <v-flex class="px-1 py-1">
                    <h2> Please note that searches for events will likely time out (especially for longer time periods - 12h or more), but should work after 2-3 timeouts. This may take up to 3 minutes.</h2>
                  </v-flex>
              </v-card>
          </v-flex>
      </v-layout>
      <v-form ref="form" v-if="this.showForm" v-model="valid" lazy-validation>
        <v-flex md12 xs12>
            <v-layout>
                
                    <v-flex md2 xs12>
                        <v-card>
                            <v-card-text>
                                <h3 :style="$store.state.textFormatting.main"> Search for:</h3>
                                <v-select v-model="querySelect" :items="queryTypes" :style="$store.state.textFormatting.main"></v-select>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex md6 xs12>
                        <v-card>
                            <v-card-text>
                                <h3 :style="$store.state.textFormatting.main"> Time From ({{tz}})</h3>
                                <v-layout>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeFrom.hour" :items="hourItems" label="Hour" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex >
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeFrom.minute" :items="minItems" label="Minutes" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md1>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeFrom.day" :items="useFromDays" label="Day" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-select v-model="timeFrom.month" :items="useFromMonths" item-text="name" item-value="number" label="Month" @change="updateFromDay" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeFrom.year" :items="YearItems" label="Year" @change="updateFromMonth" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex md6 xs12>
                        <v-card>
                            <v-card-text>
                                <h3 :style="$store.state.textFormatting.main"> Time To ({{tz}})</h3>
                                <v-layout>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeTo.hour" :items="hourItems" label="Hour" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex >
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeTo.minute" :items="minItems" label="Minutes" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md1>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeTo.day" :items="useToDays" label="Day" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-select v-model="timeTo.month" :items="useToMonths" item-text="name" item-value="number" label="Month" @change="updateToDay" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-select v-model="timeTo.year" :items="YearItems" label="Year" @change="updateToMonth" :style="$store.state.textFormatting.main"> </v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                
            </v-layout>
        </v-flex>         

          <v-flex md12 xs12>
              <v-card>
                  <v-card-text>
                      <h3 :style="$store.state.textFormatting.main"> Search Criteria </h3>
                      <v-layout>

                          <v-flex xs12 md4>
                            <v-text-field v-model="searchForm.asn" @change="runASNOwn()" label="Search ASN" :rules="asn_rules" @keyup.enter="validate" :style="$store.state.textFormatting.main">
                            </v-text-field>
                            <h6 v-if="!showASNLoad" :style="$store.state.textFormatting.main"> {{ asnorg }} </h6>
                            <v-progress-circular v-if="showASNLoad" indeterminate color="purple" :style="$store.state.textFormatting.main"></v-progress-circular>
                          </v-flex>

                          <v-flex xs12 md1></v-flex>

                          <v-flex xs12 md4>
                            <v-text-field 
                                v-model="searchForm.prefix" 
                                label="Search Prefix"
                                :rules="pre_rules" 
                                @keyup.enter="validate"
                                :style="$store.state.textFormatting.main">
                            </v-text-field>

                          </v-flex>

                          <v-flex xs12 md1></v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Events'">
                            <v-select v-model="searchForm.order_by_event" :items="orderEventItems" item-text="name" item-value="value" label="Order By" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Episodes'">
                            <v-select v-model="searchForm.order_by_episode" :items="orderEpisodeItems" item-text="name" item-value="value" label="Order By" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Notifications'">
                            <v-select v-model="searchForm.order_by_notification" :items="orderNotificationItems" item-text="name" item-value="value" label="Order By" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Events'">
                            <v-select v-model="searchForm.order_by_event2" :items="orderEventItems" item-text="name" item-value="value" label="Order By (2)" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Episodes'">
                            <v-select v-model="searchForm.order_by_episode2" :items="orderEpisodeItems" item-text="name" item-value="value" label="Order By (2)" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md4 v-if="querySelect == 'Notifications'">
                            <v-select v-model="searchForm.order_by_notification2" :items="orderNotificationItems" item-text="name" item-value="value" label="Order By (2)" :style="$store.state.textFormatting.main"> </v-select>
                          </v-flex>

                          <v-flex xs12 md1></v-flex>

                          <template v-if="querySelect == 'Events'">
                            <v-flex xs12 md4>
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-switch slot="activator" v-on="on" v-model="searchForm.include_path_based">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include 'ASN in path' events</div>
                                            </template>
                                        </v-switch>
                                    </template>
                                    <span :style="$store.state.textFormatting.main">Events where the target ASN can be present in the path, not just as the origin ASN</span>
                                </v-tooltip>
                            </v-flex>

                            <v-flex xs12 md1></v-flex>
                          </template>

                          <v-flex xs12 md4>
                              <v-tooltip top eager close-delay=500 >
                                  <template  v-slot:activator="{ on }">
                                      <v-switch slot="activator" v-on="on" v-model="searchForm.exclude_path_change">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include path change events</div>
                                            </template> 
                                        </v-switch>
                                  </template>
                                <span :style="$store.state.textFormatting.main">Events where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                              </v-tooltip>
                          </v-flex>

                          <v-flex xs12 md1></v-flex>

                          <v-flex xs12 md4>
                              <v-tooltip top eager close-delay=500 >
                                  <template  v-slot:activator="{ on }">
                                      <v-switch slot="activator" v-on="on" v-model="searchForm.exclude_first_seen">
                                          <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include first seen prefix events</div>
                                            </template>
                                        </v-switch>
                                  </template>
                                <span :style="$store.state.textFormatting.main">Events where there was no known path to the given prefix, prior to the event occuring</span>
                              </v-tooltip>
                          </v-flex>

                         

                      </v-layout>
                  </v-card-text>
              </v-card>
          </v-flex>

          <v-flex md12 xs12>
              <v-card>
                  <v-card-text>
                      <h3 :style="$store.state.textFormatting.main"> Score ranges </h3>

                      <v-layout>
                          <v-flex xs12 md12>
                              <h4 :style="$store.state.textFormatting.main"> Hijack Score </h4>
                          </v-flex>
                          <v-flex xs12 md1></v-flex>
                          <v-flex xs12 md12>
                              <h4 class="align-center" :style="$store.state.textFormatting.main"> Impact Score </h4>
                          </v-flex>
                           <v-flex xs12 md4></v-flex>
                      </v-layout>

                      <v-layout>
                          <v-flex xs11 md12>
                            <v-range-slider v-model="hsliderRange" :max="sliderMax" :min="sliderMin" class="align-center">
                                <template v-slot:prepend>
                                    <v-text-field v-model="hsliderRange[0]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" @keyup.enter="validate" :style="$store.state.textFormatting.main">
                                    </v-text-field>
                                </template>
                                <template v-slot:append>
                                    <v-text-field v-model="hsliderRange[1]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" @keyup.enter="validate" :style="$store.state.textFormatting.main">
                                    </v-text-field>
                                </template>
                            </v-range-slider>   
                          </v-flex>

                          <v-flex xs12 md1>
                          </v-flex>

                          <v-flex xs11 md12>
                            <v-range-slider v-model="isliderRange" :max="sliderMax" :min="sliderMin" class="align-center">
                                <template v-slot:prepend>
                                    <v-text-field v-model="isliderRange[0]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" @keyup.enter="validate" :style="$store.state.textFormatting.main">
                                    </v-text-field>
                                </template>
                                <template v-slot:append>
                                    <v-text-field v-model="isliderRange[1]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" @keyup.enter="validate" :style="$store.state.textFormatting.main">
                                    </v-text-field>
                                </template>
                            </v-range-slider>   
                          </v-flex>

                          <v-flex xs12 md1>
                          </v-flex>

                          <v-flex xs12 md3>
                              <v-btn 
                              :disabled="!valid" 
                              color="success"
                              class="mr-4"
                              @click="validate"
                              @keyup.enter="validate" :style="$store.state.textFormatting.main">Run Search</v-btn>
                          </v-flex>

                      </v-layout>
                  </v-card-text>
              </v-card>
          </v-flex>



      </v-form>

    <v-dialog v-model="showIfInvalid" width="600" persistent>
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> 
                Invalid Date Selection
            </v-toolbar-title>            
        </v-toolbar>
        <v-card>
            <v-layout>
                <v-card-text :style="$store.state.textFormatting.main"> 
                    It looks like the date combination you chose is not valid.<br> Please check your selection and try again.<br><br>Thank you
                </v-card-text>
            </v-layout>
            <v-layout>
                <v-spacer></v-spacer>
                <v-btn color="red" @click="showIfInvalid=!showIfInvalid" :style="$store.state.textFormatting.main"> OK <v-icon> mdi-cancel </v-icon> </v-btn>
            </v-layout>
        </v-card>
    </v-dialog>


    <v-dialog v-model="showAfterValid" width="600" persistent>
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> 
                Are you sure?
            </v-toolbar-title>            
        </v-toolbar>
        <v-card>
            <v-layout>
                <v-card-text v-if="querySelect == 'Episodes'" :style="$store.state.textFormatting.main"> 
                    Episode searches of over 14 day periods can take a long time. <br>
                    Consider shortening your search period or continue anyway.
                </v-card-text>
                <v-card-text v-if="querySelect == 'Events'" :style="$store.state.textFormatting.main"> 
                    Event searches of over 2 day periods can take a long time. <br>
                    Consider shortening your search period or continue anyway.
                </v-card-text>
                <v-card-text v-if="querySelect == 'Notifications'" :style="$store.state.textFormatting.main"> 
                    Notification searches of over 14 day periods can take a long time. <br>
                    Consider shortening your search period or continue anyway.
                </v-card-text>
            </v-layout>
            <v-layout>
                <v-btn color="red" @click="showAfterValid=!showAfterValid" :style="$store.state.textFormatting.main"> CANCEL <v-icon> mdi-cancel </v-icon> </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="afterValid" :style="$store.state.textFormatting.main"> CONTINUE <v-icon>mdi-checkbox-marked-circle</v-icon> </v-btn>
            </v-layout>
        </v-card>
    </v-dialog>

        

    <v-layout v-if="!this.showForm">
        <v-flex>
            <v-btn color="success" class="mr-4" @click="flipForm" :style="$store.state.textFormatting.main"> Show Search Form </v-btn>
        </v-flex>

    </v-layout>

    <h3> <br /> </h3>


    <v-card v-if="querySelect == 'Events'">
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> 
                Event Search Results (Times in {{tz}})
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <info>
                <template slot>
                    Events satisfying search criteria
                </template>
                <template slot="body">
                    Click on a given event to see the episode associated with the event.
                    <br />
                    The chart below shows how the number of events vary over the requested time period. To allow easy navigation of the search results, you can [click] on a bar within the chart to quickly move to that point in time.
                    <br />
                    Press the download button to download all events satisfying the criteria, in CSV format.
                    <br />
                    <br />
                    <b> Events are stored for 30 days before being deleted </b>
                </template>
            </info>
            <v-btn v-if="dataQueued==0"
                :disabled="!showData"
                small dark color="success" @click="downloadEvents" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Results
                <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>    
            </v-btn>
            <v-btn v-if="dataQueued==1"
                :disabled="!showData"
                small dark color="success" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Queuing Download <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>                
            </v-btn>
            <v-btn v-if="dataQueued==2"
                :disabled="!showData"
                small dark color="success" href="/#/rawData" target="_blank" :style="$store.state.textFormatting.main">
                <v-icon color="white">check</v-icon> Success. Click to open "Request Data page"
            </v-btn>
        </v-toolbar>
        <v-data-table 
            :headers="headersEvent" 
            :items="searchResults" 
            :key="id"
            :rows-per-page-items="rowsPerPageItems" 
            :pagination.sync="pagination" 
            :loading="loading"
            :total-items="totalResults"
            v-if="showData">    
            <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                <span slot="activator" :style="$store.state.textFormatting.main">
                    <div v-for="line in props.header.text" :key="line.index">
                        <div> {{ line }} </div>
                    </div>
                </span>
                <span :style="$store.state.textFormatting.main">
                    {{ props.header.ad_text }}
                </span>
                </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
                <tr @click="clickHandlerEvent(props.item)">
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.date }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.time }}</td>
                    <td> {{ props.item.ev_type }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.peer_asn }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.path_old }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.path_new }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.impact_score }}</td>
                  <!--  <td class="text-xl-center"> {{ props.item.sub_hijack_score }}</td>
                    <td class="text-xl-center"> {{ props.item.sub_impact_score }}</td> -->
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.event_count }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_scope }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_subtype }}</td>
                    <!-- <td class="text-xl-center"> {{ props.item.controlled_prefix_orgs }}</td> !-->
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.edit_distance }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.pathchange_type }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.asn_geocomparison }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix_vs_asn_geo }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.bogon }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.route_leak_flag }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.restricted_dns }}</td>
                </tr>
            </template>
            <template slot="no-data">
                <v-alert :value="true" :color="erColor" icon="warning" :style="$store.state.textFormatting.main">
                    {{ resError }}
                </v-alert>
            </template>
        </v-data-table>
        <v-card color="rgba(0, 0, 0, 0.05)" style="flex-grow: 1; min-height: 0;">
            <div class="chart-container">
                <barchart ref="chart" :chart-data="chartData" :options="options" :styles="myStyles"></barchart>
            </div>
        </v-card>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="rerunMessage"> <h2> {{ rerunMessage }} </h2> </v-card-text>
                <v-card-text v-if="searchWindows.length > 0">
                    <div v-if="searchWindowsStatus>0">
                        Loading data... please wait.
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
<!--                    <div v-for="timewindow in searchWindows" :key="timewindow.id">
                        <div v-if="timewindow.datarequired" style="display:flex">
                            <div>{{ timewindow.date }} {{ timewindow.time }}  :</div>
                            <div v-if="timewindow.result"> {{ timewindow.result.length }} events </div> 
                            <div> <v-progress-circular small v-if="timewindow.loading" indeterminate color="purple" ></v-progress-circular> </div>
                        </div>
                    </div> -->
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="searchWindowsCount.length > 0">
                    <div v-if="searchWindowsCountStatus>0">
                        Looking for matching results... please wait. {{ searchWindowsCountPercentage }}%
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
<!--                    <div v-for="timewindowcount in searchWindowsCount" :key="timewindowcount.id">
                        <div v-if="timewindowcount.loading" style="display:flex">
                            <div>{{ timewindowcount.id }} {{ timewindowcount.date }} {{ timewindowcount.time }}  :</div>
                            <div v-if="timewindowcount.result"> {{ timewindowcount.result.length }} count </div> 
                            <div> <v-progress-circular small v-if="timewindowcount.running" indeterminate color="purple" ></v-progress-circular> </div>
                        </div>
                    </div> -->
                </v-card-text>
            </v-card>
        </v-flex>

    </v-card>

    <v-card v-if="querySelect == 'Episodes'">
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> 
                Episode Search Results (Times in {{tz}})
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <info>
                <template slot>
                    Episodes satisfying search criteria
                </template>
                <template slot="body">
                    Click on a given episode to see the episode breakdown.
                    <br />
                    The chart below shows how the number of episodes vary over the requested time period. To allow easy navigation of the search results, you can [click] on a bar within the chart to quickly move to that point in time.
                    <br />
                    Press the download button to download all episodes satisfying the criteria, in CSV and JSON format. 
                    (NOTE: Episode results are downloaded as a )
                    <br />
                    <b> Episodes are stored for 30 days before being deleted</b>
                </template>
            </info>
            <v-btn v-if="dataQueued==0"
                :disabled="!showData"
                small dark color="success" @click="downloadEpisodes" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Results
                <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>    
            </v-btn>
            <v-btn v-if="dataQueued==1"
                :disabled="!showData"
                small dark color="success" @click="downloadEpisodes" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Queuing Download <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>                
            </v-btn>
            <v-btn v-if="dataQueued==2"
                :disabled="!showData"
                small dark color="success" href="/#/rawData" target="_blank" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Queued <v-icon color="green">check</v-icon> Click to open Request Data page                
            </v-btn>

        </v-toolbar>
            <v-data-table 
                :headers="headersEpisode" 
                :items="searchResults" 
                :pagination.sync="pagination" 
                :total-items="totalResults"
                :rows-per-page-items="rowsPerPageItems" 
                :loading="loading"
                :key="id"
            v-if="showData">
            <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                <span slot="activator" :style="$store.state.textFormatting.main">
                    <div v-for="line in props.header.text" :key="line.index">
                        <div> {{ line }} </div>
                    </div>
                </span>
                <span :style="$store.state.textFormatting.main">
                    {{ props.header.ad_text }}
                </span>
                </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
                <tr  @click="props.expanded = !props.expanded; clickHandler(props.item.prefix, 
                            props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min)">
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.interval_start.date}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.interval_start.time}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.episode_type}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.prefix}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.non_direct_prefix}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.event_count }}</td>
                </tr>
            </template>
            <template slot="no-data">
                <v-alert :value="true" :color="erColor" icon="warning" :style="$store.state.textFormatting.main">
                {{ resError }}
                </v-alert>
            </template>
        </v-data-table>
        <v-card color="rgba(0, 0, 0, 0.05)" style="flex-grow: 1; min-height: 0;">
            <div class="chart-container">
                <barchart ref="chart" :chart-data="chartData" :options="options" :styles="myStyles"></barchart>
            </div>
        </v-card>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="rerunMessage"> <h2> {{ rerunMessage }} </h2> </v-card-text>
                <v-card-text v-if="searchWindows.length > 0">
                    <div v-if="searchWindowsStatus>0">
                        Loading data... please wait.
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="searchWindowsCount.length > 0">
                    <div v-if="searchWindowsCountStatus>0">
                        Looking for matching results... please wait {{ searchWindowsCountPercentage }}%.
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-card>

    
    <v-card v-if="querySelect == 'Notifications'">
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> 
                Notification Search Results (Times in {{tz}})
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <info>
                <template slot>
                    Notifications satisfying search criteria
                </template>
                <template slot="body">
                    Click on a given notification to see the episode breakdown, including those events which didn't pass the user defined thresholds.
                    <br />
                    Press the download button to download all notifications satisfying the criteria, in CSV format.
                    <br />
                    <br />
                    <b> Notifications are stored for 30 days before being deleted </b>
                </template>
            </info>
            <v-btn v-if="dataQueued==0"
                :disabled="!showData"
                small dark color="success" @click="downloadNotifications" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Results
                <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>    
            </v-btn>
            <v-btn v-if="dataQueued==1"
                :disabled="!showData"
                small dark color="success" @click="downloadNotifications" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Queuing Download <v-progress-circular v-if="dataQueued==1" small indeterminate color="purple" ></v-progress-circular>                
            </v-btn>
            <v-btn v-if="dataQueued==2"
                :disabled="!showData"
                small dark color="success" href="/#/rawData" target="_blank" :style="$store.state.textFormatting.main">
                <v-icon>save_alt</v-icon> Queued <v-icon color="green">check</v-icon> Click to open Request Data page                
            </v-btn>
        </v-toolbar>
        <v-data-table
            :headers="headersNotification" 
            :items="searchResults" 
            :pagination.sync="pagination" 
            :total-items="totalResults"
            :rows-per-page-items="rowsPerPageItems" 
            :key="id"
            :loading="loading"
            >    
            <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                <span slot="activator" :style="$store.state.textFormatting.main">
                    <div v-for="line in props.header.text" :key="line.index">
                        <div> {{ line }} </div>
                    </div>
                </span>
                <span :style="$store.state.textFormatting.main">
                    {{ props.header.ad_text }}
                </span>
                </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
                <tr  @click="props.expanded = !props.expanded; clickHandler(props.item.prefix, 
                            props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min)">
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.interval_start.date}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{props.item.interval_start.time}} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.alert_type }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }} </td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>
                </tr>
            </template>
            <template slot="no-data">
                <v-alert :value="true" :color="erColor" icon="warning" :style="$store.state.textFormatting.main">
                {{ resError }}
                </v-alert>
            </template>
        </v-data-table>
        <v-card color="rgba(0, 0, 0, 0.05)" style="flex-grow: 1; min-height: 0;">
            <div class="chart-container">
                <barchart ref="chart" :chart-data="chartData" :options="options" :styles="myStyles"></barchart>
            </div>
        </v-card>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="rerunMessage"> <h2> {{ rerunMessage }} </h2> </v-card-text>
                <v-card-text v-if="searchWindows.length > 0">
                    <div v-if="searchWindowsStatus>0">
                        Loading data... please wait.
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex v-if="showLoad">
            <v-card>
                <v-card-text v-if="searchWindowsCount.length > 0">
                    <div v-if="searchWindowsCountStatus>0">
                        Looking for matching results... please wait {{ searchWindowsCountPercentage }}%.
                        <v-progress-circular small indeterminate color="purple" ></v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-card>
  </v-container>
</template>


<script>
import { API, graphqlOperation } from 'aws-amplify';
import barchart from '../../shared/operational/BarChart.js';
import info from '../../shared/operational/infopopout.vue';
// import { alerttable, eventtable } from '../../shared/operational/infopopout.js'
import downloadcsv from 'vue-json-csv';
import { findParentComponentByName } from '../utils/findParent.js'
import moment from 'moment-timezone';


export default {
    name: 'searchEvents',
    components: {
        info,
        barchart,
        downloadcsv
    },
    icons: {
        iconfont: 'mdi'
    },
    data: () => ({
        chartData: {
            labels: [],
            datasets: [
                {
                label: 'None',
                backgroundColor: '#f87979',
                data: []
                }
            ]
        },
        options: {
            animation: {
                duration:0
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {display: false}
        },
        loading: true,
        ep_labels: [1],
        ep_value: [0],
        totalResults: 1,
        rowsdisplayed: 0,
        windowsize: [0,100],
        showData: false,
        showLoad: false,
        showForm: true,
        organisation: '',
        resError: "No results found",
        erColor: "success",
        valid: false,
        lazy: false,
        asn_rules: [ v => /(^$|^\d+$)/.test(v) || 'ASN must be non-negative integer'],
        pre_rules: [ v => /(^$|^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))$|^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([1-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))$)/.test(v) || 'Address must be valid IPv4 or IPv6' ],
        asn_search: 0,
        timeFrom: {"hour": '00', "minute": '00', "day": "01", "month": "01", "year": 2019},
        timeTo: {"hour": '00', "minute": '00', "day": "01", "month": "01", "year": 2019},
        searchForm: {
            "asn": '',
            "prefix": '',
            "time_from": 0,
            "time_to": 0,
            "h_greater_than": 0,
            "i_greater_than": 0,
            "h_less_than": 99,
            "i_less_than": 99,
            "order_by_event": "hijack_score",
            "order_by_episode": "hijack_score_mean",
            "order_by_notification": "hijack_score_mean",
            "order_by_event2": "time_5min",
            "order_by_episode2": "time_5min",
            "order_by_notification2": "time_5min",
            "include_path_based": false,
            "exclude_path_change": false,
            "exclude_first_seen": false
        },
        vType: 'v4',
        rowsPerPageItems: [10, 20, 30, 40, 50],
        pagination: {
            rowsPerPage: 10
        },
        id: 1,
        headersEvent: [
            { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
            { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'},
            { text: ['Event Type'], value: 'ev_type', align:'centre', ad_text: 'The type of event, see glossary for details'},
            { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
            { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
            { text: ['Peer', 'ASN'], value:'peer_asn', align:'centre', ad_text: 'AS from which we are seeing the advertisment'},
            { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
            { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
            { text: ['Old', 'ASN Path'], value:'path_old', align:'centre', ad_text: 'AS path before the alert occuring'},
            { text: ['New', 'ASN Path'], value:'path_new', align:'centre', ad_text: 'AS path after alert occuring'},
            { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
            { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
            { text: ['Repeat', 'Event', 'Count'], value:'event_count', align:'centre', ad_text: 'How many times this exact alert occured in the 5 minute window'},
            { text: ['Hijack', 'Scope'], value:'hijack_scope', align:'centre', ad_text: 'The difference in CIDR between the advertised prefix and the parent/child in the case of a sub/super ownership assertion'},
            { text: ['Hijack', 'Subtype'], value:'hijack_subtype', align:'centre', ad_text: 'Full or observed. Full means we\'ve not seen this AS asserting ownership over this prefix before, observed means we have'},
            { text: ['Edit', 'Distance'], value:'edit_distance', align:'centre', ad_text: 'The amount of additions/ deletions/ exchanges to get from the old to the new AS path'},
            { text: ['Path', 'Change', 'Type'], value:'pathchange_type', align:'centre', ad_text: 'How many ASNs (from the origin end) are the same, between the old and new AS path (see glossary for example)'},
            { text: ['ASN', 'Geocomparison'], value:'asn_geocomparison', align:'centre', ad_text: '-1 for no data available, 0 for no correlation up to 1 for perfect correlation'},
            { text: ['Prefix', 'vs ASN', 'Geocomparison'], value:'prefix_vs_asn_geo', align:'centre', ad_text: '-1 for no data available, 0 for no correlation up to 1 for perfect correlation'},
            { text: ['Bogon'], value:'bogon', align:'centre', ad_text: 'Will display the bogon prefix if we have one'},
            { text: ['Route', 'Leak'], value:'route_leak_flag', align:'centre', ad_text: '1 if route leak, 0 if not'},
            { text: ['Restricted', 'DNS'], value:'restricted_dns', align:'centre', ad_text: 'If we have hit a restricted DNS entry, it will display here'}
        ],
        headersEpisode: [
            { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
            { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'},
            { text: ['Episode Type'], value: 'episode_type', align:'centre', ad_text: 'The type of episode, will be simplified versus what you get from an event, since less information is available'},
            { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
            { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
            { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
            { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
            { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
            { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
            { text: ['Event', 'Count'], value:'event_count', align:'centre', ad_text: 'How many events comprise this episode'},
        ],
        headersNotification: [
            { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
            { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'},
            { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
            { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
            { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
            { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
            { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
            { text: ['Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
            { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
            { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'}
        ],
        hourItems:  ["00","01","02","03","04","05","06","07","08","09",10,11,12,13,14,15,16,17,18,19,20,21,22,23],
        minItems:  ["00", "05", 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
        dayItems: ["01","02","03","04","05","06","07","08","09",10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
        useToDays: [],
        useFromDays: [],
        MonthItems: [
            {name: "January", number: "01"},
            {name: "Feburary", number: "02"},
            {name: "March", number: "03"},
            {name: "April", number: "04"},
            {name: "May", number: "05"},
            {name: "June", number: "06"},
            {name: "July", number: "07"},
            {name: "August", number: "08"},
            {name: "September", number: "09"},
            {name: "October", number: "10"},
            {name: "November", number: "11"},
            {name: "December", number: "12"}
        ],
        useFromMonths: [],
        useToMonths: [],
        monthDays: {
            "01": 31,
            "02": 28,
            "03": 31,
            "04": 30,
            "05": 31,
            "06": 30,
            "07": 31,
            "08": 31,
            "09": 30,
            "10": 31,
            "11": 30,
            "12": 31
        },
        orderEventItems: [
            {name: "Hijack Score", value: "hijack_score"},
            {name: "Impact Score", value: "impact_score"},
            {name: "Origin ASN (New)", value: "origin_asn_new"},
            {name: "Origin ASN (Old)", value: "origin_asn_old"},
            {name: "Timestamp", value: "time_5min"},
            {name: "Event Count", value: "event_count"},
            {name: "Peer ASN", value: "peer_asn"}
        ],
        orderEpisodeItems: [
//            {name: "Hijack Score", value: "hijack_score_mean"},
//            {name: "Impact Score", value: "impact_score_mean"},
//            {name: "Origin ASN (New)", value: "origin_asn_new"},
//            {name: "Origin ASN (Old)", value: "origin_asn_old"},
            {name: "Timestamp", value: "time_5min"},
//            {name: "Event Count", value: "event_count"}
        ],
        orderNotificationItems: [
            {name: "Hijack Score", value: "hijack_score_mean"},
            {name: "Impact Score", value: "impact_score_mean"},
            {name: "Origin ASN (New)", value: "origin_asn_new"},
            {name: "Origin ASN (Old)", value: "origin_asn_old"},
            {name: "Timestamp", value: "time_5min"},
            {name: "Event Count", value: "event_count"},
            {name: "Validation", value: "validation"},
            {name: "ASN Class", value: "asn_class"},
            {name: "Email Count", value: "email_count"}
        ],
        YearItems: [2019],
        hsliderRange: [0, 99],
        isliderRange: [0, 99],
        sliderMin: 0,
        sliderMax: 99,
        search: false,
        scoredEvents: [],
        scoredEpisodes: [],
        notifications: [],
        searchResults: [],
        queryTypes: ["Episodes", "Events", "Notifications"],
        querySelect: "Events",
        asnorg: '(This will search all ASNs)',
        ownerData: null,
        showASNLoad: false,
        showIfInvalid:false,
        showAfterValid: false,
        progress_message: '',
        searchWindows: [],
        searchWindowsCount: [],
        searchWindowsStatus: 0,
        searchWindowsCountStatus: 0,
        searchWindowsCountPercentage: 0,
        allowResearches: false,
        rerunMessage: false,
        apicount:0,
        drawtime:new Date(),
        buckets: [],
        updatingresults: false,
        querytime:new Date(),
        concurrentEpisdodeQueries:9,
        concurrentEventQueries:9,
        concurrentNotificationQueries:9,
        searchRetries:10,
        ticklabels:[1,2],
        ticktimes:[],
        height:200,
        bar_highlight:[],
        maxChartValue:0,
        bar_times:[],
        tz:"UTC",
        gradientFill: null,
        dataQueued:0
    }),
    mounted () {
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
        this.getYears();
        this.organisation = this.$store.state.user.organisation;
        this.headersNotification[5].text[0] = this.organisation;
        if (this.$route.params.asn) {
    //        console.log(this.$route)
            this.searchForm.asn = this.$route.params.asn;
            this.runASNOwn();
            this.querySelect = "Episodes";
            this.setDefaultTimes();
        } else if (!this.$store.state.lastSearch) {
        //    console.log("MUB!");
            this.setDefaultTimes();
        } else {
          //  console.log(this.$store.state.lastSearch)
            this.preSearch();
            this.updateFromMonth();
            this.updateToMonth();
            this.updateToDay();
            this.updateFromDay();
        }
        this.options={
            animation: {
                duration:0
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: this.quickmove,
            legend: {display: false},
            scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(255,99,132,0.2)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 25,
                            beginAtZero: true
                        },
                        gridLines: {
                        display: false
                    }
                }]          
            }
        }



    },
    computed: {
        myStyles() {
            return {
                height: `${this.height}px`,
                position: 'relative'
            }
        }
    },
    methods: {
        updateToDay: async function () {
            this.useToDays = [];
            var mon = this.timeTo.month;
            var yr = this.timeTo.year;
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            let nmonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let nday = ndate.getUTCDate();
            ndate.setDate(ndate.getUTCDate() - 30);
            let oyear = ndate.getUTCFullYear();
            let omonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let oday = ndate.getUTCDate();
//            console.log("smonth: " + mon);
//            console.log("syear: " + yr);
//            console.log(nyear);
//            console.log(nmonth);
//            console.log(oyear);
//            console.log(omonth);
            var i=0;
            if (yr == nyear && mon == nmonth) {
                for(i = 0 ; i < this.dayItems.length ; i++){
                    if(i < nday){
                        this.useToDays.push(this.dayItems[i])
                    }
                }
            }
            if (yr == oyear && mon == omonth && omonth != nmonth) {
                for(i = 0 ; i < this.dayItems.length ; i++){
                    if(i > oday && i < this.monthDays[mon]){
                        this.useToDays.push(this.dayItems[i])
                    }
                }
            }
        },
        updateToMonth: async function () {
            this.useToMonths = [];
            var yr = this.timeTo.year;
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            let nmonth = ndate.getUTCMonth();
            ndate.setDate(ndate.getUTCDate() - 30);
            let oyear = ndate.getUTCFullYear();
            let omonth = ndate.getUTCMonth();
            if (yr == nyear) {
                this.useToMonths.push(this.MonthItems[nmonth]);
            }
            if (yr == oyear && nmonth != omonth) {
                this.useToMonths.push(this.MonthItems[omonth]);
            }
        },
        updateFromDay: async function () {
            this.useFromDays = [];
            var mon = this.timeFrom.month;
            var yr = this.timeFrom.year;
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            let nmonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let nday = ndate.getUTCDate();
            ndate.setDate(ndate.getUTCDate() - 30);
            let oyear = ndate.getUTCFullYear();
            let omonth = ("0" + (ndate.getUTCMonth() + 1)).slice(-2);
            let oday = ndate.getUTCDate();
//            console.log("smonth: " + mon);
//            console.log("syear: " + yr);
//            console.log(nyear);
//            console.log(nmonth);
//            console.log(oyear);
//            console.log(omonth);
            var i=0;
            if (yr == nyear && mon == nmonth) {
                for(i = 0 ; i < this.dayItems.length ; i++){
                    if(i < nday){
                        this.useFromDays.push(this.dayItems[i])
                    }
                }
            }
            if (yr == oyear && mon == omonth && omonth != nmonth) {
                for(i = 0 ; i < this.dayItems.length ; i++){
                    if(i > oday && i < this.monthDays[mon]){
                        this.useFromDays.push(this.dayItems[i])
                    }
                }
            }
        },
        updateFromMonth: async function () {
            var yr = this.timeFrom.year;
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            let nmonth = ndate.getUTCMonth();
            ndate.setDate(ndate.getUTCDate() - 30);
            let oyear = ndate.getUTCFullYear();
            let omonth = ndate.getUTCMonth();
            if (yr == nyear) {
                this.useFromMonths.push(this.MonthItems[nmonth]);
            }
            if (yr == oyear && nmonth != omonth) {
                this.useFromMonths.push(this.MonthItems[omonth]);
            }
        },
        getYears: async function () {
            var ndate = new Date();
            let nyear = ndate.getUTCFullYear();
            ndate.setDate(ndate.getUTCDate() - 30);
            let oyear = ndate.getUTCFullYear();
            if (nyear == oyear) {
                this.YearItems = [nyear];
            } else {
                this.YearItems = [oyear, nyear];
            }
        },
        preSearch: async function () {
            this.querySelect = this.$store.state.lastSearch.searchType;
            this.searchForm = this.$store.state.lastSearch.form;
            this.timeFrom = this.$store.state.lastSearch.timeFrom;
            this.timeTo = this.$store.state.lastSearch.timeTo;
            this.isliderRange = this.$store.state.lastSearch.iSlider;
            this.hsliderRange = this.$store.state.lastSearch.hSlider;
        },
        runASNOwn: async function () {
            if (this.searchForm.asn) {
                if (this.searchForm.asn != 0 && this.searchForm.asn != '') {
                    this.getASNOwn(this.searchForm.asn);
                } else {
                    this.asnorg = "(This will search all ASNs)";
                }
            } else {
                this.asnorg = "(This will search all ASNs)";
            }
        },
        getASNOwn: async function (asn) {
            this.showASNLoad = true;
            this.asnorg = null;
            try {
                var qry = `query getASNOwner { getASNOwner ( asn: "` + asn + `" ) {
                        organisation
                    }
                }`;
//                console.log(qry)
                const ASNOwnData = await API.graphql(graphqlOperation(qry));
                if (ASNOwnData.data.getASNOwner) {
                    var ownData = ASNOwnData.data.getASNOwner;
//                    console.log(ownData);
                    if (ownData.length > 0) {
                        this.ownerData = ownData;
                        this.asnorg = ownData[0].organisation;
                        this.showASNLoad = false;
                    } else {
                        this.asnorg = "Unknown";
                        this.showASNLoad = false;
                    }
                }
            } catch (err) {
                this.asnorg = "Unknown";
//                console.log(err);
                this.showASNLoad = false;
            }
        },
        setFromTime: async function() {
            if (!this.hourItems.includes(this.timeFrom.hour)) {
                this.timeFrom.hour = "00"
            }
            if (!this.minItems.includes(this.timeFrom.minute)) {
                this.timeFrom.minute = "00"
            }
            if (!this.hourItems.includes(this.timeTo.hour)) {
                this.timeTo.hour = "00"
            }
            if (!this.minItems.includes(this.timeTo.minute)) {
                this.timeTo.minute = "00"
            }
            this.searchForm.time_from = moment.tz(this.timeFrom.year + '-' + this.timeFrom.month + '-' + this.timeFrom.day + 'T' + this.timeFrom.hour + ':' + this.timeFrom.minute + ':00',this.tz).unix()
            this.searchForm.time_to = moment.tz(this.timeTo.year + '-' + this.timeTo.month + '-' + this.timeTo.day + 'T' + this.timeTo.hour + ':' + this.timeTo.minute + ':00', this.tz).unix()
//            var date_obj1 = new Date( this.timeFrom.year + '-' + this.timeFrom.month + '-' + this.timeFrom.day + 'T' + this.timeFrom.hour + ':' + this.timeFrom.minute + ':00' );
//            this.searchForm.time_from = date_obj1.getTime() / 1000;
//            var date_obj2 = new Date( this.timeTo.year + '-' + this.timeTo.month + '-' + this.timeTo.day + 'T' + this.timeTo.hour + ':' + this.timeTo.minute + ':00' );
//            this.searchForm.time_to = date_obj2.getTime() / 1000;
        },
        setDefaultTimes: async function() {
            var date_obj1 = new Date()
            this.timeTo.year = date_obj1.getUTCFullYear();
            this.timeFrom.year = date_obj1.getUTCFullYear(); 
            var month_obj = date_obj1.getUTCMonth() + 1;
            var day_obj = date_obj1.getUTCDate();
            if (day_obj < 10) {
                this.timeTo.day = "0" + String(day_obj)
                this.timeFrom.day = "0" + String(day_obj)
            } else {
                this.timeTo.day = day_obj
                this.timeFrom.day = day_obj
            }
            if (month_obj < 10) {
                this.timeTo.month = "0" + String(month_obj)
                this.timeFrom.month = "0" + String(month_obj)
            } else {
                this.timeTo.month = String(month_obj)
                this.timeFrom.month = String(month_obj)
            }
            this.updateFromMonth();
            this.updateToMonth();
            this.updateToDay();
            this.updateFromDay();
        },
        validate () {
         //   console.log("Validating")
            if (this.$refs.form.validate()) {
                var date_from=moment(this.timeFrom.year+"-"+this.timeFrom.month+"-"+this.timeFrom.day+" "+this.timeFrom.hour+":"+this.timeFrom.minute)
                var date_to=moment(this.timeTo.year+"-"+this.timeTo.month+"-"+this.timeTo.day+" "+this.timeTo.hour+":"+this.timeTo.minute)
                var longtime=24
            //    console.log(this.querySelect)
                if (this.querySelect=="Events") {
                    longtime=24*2
                } else if (this.querySelect=="Episodes") {
                    longtime=24*14
                } else if (this.querySelect=="Notifications") {
                    longtime=24*14
                }
                if (date_from.isValid() && date_to.isValid()) {
                    if (date_from<date_to){
             //           console.log(date_to.diff(date_from,'hours'))
                        if (date_to.diff(date_from,'hours')>longtime){
                            this.showAfterValid=true
                        } else {
                            this.afterValid()
                        }
                    } else {
                        this.showIfInvalid=true
                    }
                } else {
                    this.showIfInvalid=true
                }
            }
        },
        afterValid: async function () {
            this.$store.state.lastSearch = {
                searchType: this.querySelect,
                form: this.searchForm,
                timeFrom: this.timeFrom,
                timeTo: this.timeTo,
                iSlider: this.isliderRange,
                hSlider: this.hsliderRange
            }
            this.showAfterValid = false;
            this.querytime=new Date()
            this.dataQueued=0
            if (this.querySelect == 'Events') {
                this.searchResults=[];
                this.runSearchSplit();
            } else if (this.querySelect == 'Episodes') {
                this.searchResults=[];
                this.runSearchSplit();
            } else {
                this.searchResults=[];
                this.runSearchSplit();
//                this.notificationData=[];
//                this.runNotificationSearch();
            }
        },
        clickHandler: function (prefix, old_asn, new_asn, time) {
            var paramatersCombined = prefix+"~"+old_asn+"~"+new_asn+"~"+time
            let routeData = this.$router.resolve({name: 'Alert From Top 10', params: {prefix: paramatersCombined}});
            window.open(routeData.href, '_blank');
        },
        clickHandlerEvent: function (allProps) {
//            console.log(allProps)
            var paramatersCombined = allProps.prefix+"~"+allProps.origin_asn_old+"~"+allProps.origin_asn_new+"~"+allProps.episode_start
            let routeData = this.$router.resolve({name: 'Alert From Top 10', params: {prefix: paramatersCombined}});
            window.open(routeData.href, '_blank');
        },
        setScoreBounds: function () {
            this.searchForm.h_greater_than = this.hsliderRange[0];
            this.searchForm.i_greater_than = this.isliderRange[0];
            this.searchForm.h_less_than = this.hsliderRange[1];
            this.searchForm.i_less_than = this.isliderRange[1];
        },
        runEventSearchSplit: async function () {
            this.showData = false;
            this.showLoad = true;
            this.allowResearches = false;
            this.rerunMessage = false;
            this.scoredEvents = [];
            this.setFromTime();
            this.setScoreBounds();
            var t_from = this.searchForm.time_from
            var t_to = this.searchForm.time_to
            var timewindows = []
            var id = 1
            while ( t_from < t_to ) {
                var d = new Date(t_from * 1000);
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":00";
                timewindows.push({
                    'id': id,
                    'timestamp': t_from,
                    'time': timeFormatted,
                    'date': dateFormatted,
                    'n_events': 0,
                    'loading': true,
                    'result': null
                })
                t_from += 3600
                id += 1
            }
            //console.log(timewindows)
            this.searchWindows = timewindows
            this.runWindows(this.searchWindows)
        },
        eventSearchSplit: async function (t,i) {
            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }
            var pre2search = this.searchForm.prefix;
            var retrycount=0
            var event=null
            var thistime=this.querytime
            var abort=false
            while (retrycount<this.searchRetries && event==null && abort==false){
                t.running=false
                abort=await this.searchThrottler(i,this.concurrentEventQueries,thistime,this.searchWindows)
                t.running=true
                if (!abort){
                    try {
                        var getSearchEventsQuery = `query getSearchEventsQuery { getSearchEvents1Hour(
                            asn: "`+ a + `",
                            prefix: "`+ pre2search + `",
                            time_from: `+ t.timestamp + `,
                            h_greater_than: `+ this.searchForm.h_greater_than + `,
                            i_greater_than: `+ this.searchForm.i_greater_than + `,
                            h_less_than: `+ this.searchForm.h_less_than + `,
                            i_less_than: `+ this.searchForm.i_less_than + `,
                            order_by: "`+ this.searchForm.order_by_event + `//` + this.searchForm.order_by_event2 + `",
                            include_path_based: `+ this.searchForm.include_path_based + `,
                            exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                            exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                            offset: `+t.offset+`,
                            limit: `+t.limit+` ) { 
                                prefix 
                                origin_asn_new
                                origin_asn_old
                                episode_start
                                human_time
                                peer_asn
                                path_new
                                path_old
                                hijack_scope
                                hijack_subtype
                                edit_distance
                                pathchange_type
                                asn_geocomparison
                                prefix_vs_asn_geo
                                restricted_dns
                                bogon
                                route_leak_flag
                                hijack_score
                                impact_score
                                sub_hijack_score
                                sub_impact_score
                                event_count
                                non_direct_asn_type
                                non_direct_prefix
                            } 
                        }`;
//                        console.log("EVENTS QUERY")
//                        console.log(getSearchEventsQuery);
                        const eventData = await API.graphql(graphqlOperation(getSearchEventsQuery));
                        event=false;
                        if (!eventData) {
                            event = false;
                        } else {
                            event = eventData.data.getSearchEvents1Hour;
  //                          t.loading=false;
                            //console.log(event);
                        }
                    } catch(err) {
                        console.log(err)
                        console.log(err.errors[0].message)
                        console.log("An error has occurred")
//                        t.loading = false
                        //this.scoredEvents = [];
                        //this.$store.state.lastSearch = false;
                        return 'error'
                    }
                }
                t.running=false
            }
            if (!event) {
                t.loading = false
                return []
            } else {
                if (event.length == 0 || event === undefined || !event) {
                    t.loading = false
                    return []
                } else {
                    var urldata = window.location.origin + "/#/alertFromTop10/"
                    for (var n = 0; n < event.length; n++) {
                        event[n].ev_type = "";
                        event[n].alert_url = urldata + event[n].prefix.replace("/", "%2F") + "~" + event[n].origin_asn_old + "~" + event[n].origin_asn_new + "~" + event[n].episode_start
                        if (event[n].bogon != null) {
                            //eventType.push({name: "Bogon Advertised", value: event[n].bogon, fatal: true})
                            event[n].ev_type = "Bogon";
                        } else if (event[n].restricted_dns != null) {
                            //eventType.push({name: "Route DNS Server Advertised", value: event[n].restricted_dns, fatal: true})
                            event[n].ev_type = "Restricted DNS";
                        } else if (event[n].origin_asn_old == 0) {
                            event[n].ev_type = "First Seen Prefix";
                        } else if (event[n].hijack_scope > 0 && (event[n].hijack_subtype != null || event[n].path_old.length > 5)) {
                            if (event[n].hijack_subtype == "full") {
                            event[n].ev_type = "Full Subownership Assertion";
                            } else {
                            event[n].ev_type = "Previously Observed Subownership Assertion";
                            }
                        } else if (event[n].origin_asn_old == event[n].origin_asn_new) {
                            if (event[n].pathchange_type != -1) {
                            event[n].ev_type = "Path Change " + event[n].pathchange_type;
                            } else {
                            event[n].ev_type = "Path Change";
                            }
                        } else if (event[n].hijack_scope == 0) {
                            if (event[n].hijack_subtype == "full") {
                            event[n].ev_type = "Full Ownership Assertion";
                            } else {
                            event[n].ev_type = "Previously Observed Ownership Assertion";
                            }
                        } else if (event[n].hijack_scope < 0) {
                            if (event[n].hijack_subtype == "full") {
                            event[n].ev_type = "Full Superownership Assertion";
                            } else {
                            event[n].ev_type = "Previously Observed Superownership Assertion";
                            }
                        } else {
                            event[n].ev_type = "Other";
                        }
                        var epochTime = event[n].episode_start
                        var dateTime = this.convertEpochtoTimeDate(epochTime);
                        event[n].time_5min = epochTime
                        event[n].interval_start  = dateTime
                    }
                    t.loading = false
                //    console.log(event)
                    return event;
                }
            }
    //        t.loading = false
    //        return []
        },
        eventSearchSplitCount: async function (t,i) {
            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }
            var retrycount=0
            var event=null
            var thistime=this.querytime
            var abort=false
            var pre2search = this.searchForm.prefix;
            abort=await this.searchThrottler(i,this.concurrentEventQueries,thistime,this.searchWindowsCount)
            t.running=true
            t.loading=true
            while (retrycount<this.searchRetries && event==null && abort==false){
                if (!abort){
                    try {
                        var getSearchEventsQueryCount = `query getSearchEventsQueryCount { getSearchEvents1HourCount(
                            asn: "`+ a + `",
                            prefix: "`+ pre2search + `",
                            time_from: `+ t.timestamp + `,
                            h_greater_than: `+ this.searchForm.h_greater_than + `,
                            i_greater_than: `+ this.searchForm.i_greater_than + `,
                            h_less_than: `+ this.searchForm.h_less_than + `,
                            i_less_than: `+ this.searchForm.i_less_than + `,
                            order_by: "`+ this.searchForm.order_by_event + `//` + this.searchForm.order_by_event2 + `",
                            include_path_based: `+ this.searchForm.include_path_based + `,
                            exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                            exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                            offset: 0,
                            limit: 2000
                            ) { 
                                time_5min,
                                event_count 
                            } 
                        }`;
//                        console.log(getSearchEventsQueryCount)
//                        console.log("starting query "+i)
                        const eventDataCount = await API.graphql(graphqlOperation(getSearchEventsQueryCount));
                        event=false;
                        if (!eventDataCount) {
                            event = false;
                        } else {
                            event = eventDataCount.data.getSearchEvents1HourCount;
                        }
                    } catch(err) {
                        console.log(err)
                        console.log(i + " - " + err.errors[0].message)
                        console.log("An error has occurred")
                    }
                }
            }
            if (thistime==this.querytime){
                if (!event) {
                    this.searchWindowsCount[i].result=[{"time_5min":0,"event_count":-1},]
                } else {
                    this.searchWindowsCount[i].result=event
                }
            }
            t.running=false
        },

        downloadEvents: async function() {
            try {
                    var t_from = this.searchForm.time_from
                    var t_to = this.searchForm.time_to
                    var collector="events"
                    this.dataQueued=1
                    var filters = {
                        "prefix":this.searchForm.prefix, 
                        "asn":this.searchForm.asn,
                        "path":this.searchForm.asn,
                        "h_greater_than": this.searchForm.h_greater_than,
                        "i_greater_than": this.searchForm.i_greater_than,
                        "h_less_than": this.searchForm.h_less_than,
                        "i_less_than": this.searchForm.i_less_than,
                        "order_by": this.searchForm.order_by_episode + "//" + this.searchForm.order_by_episode2,
                        "include_path_based": this.searchForm.include_path_based,
                        "exclude_path_change": !this.searchForm.exclude_path_change,
                        "exclude_first_seen": !this.searchForm.exclude_first_seen
                    };
                    var download_events=`mutation createRDDJob {
                        createRDDJob(rdd_usertype:"user",
                            rdd_start:"` + t_from + `",
                            rdd_finish:"` + t_to + `",
                            rdd_filters: "` + JSON.stringify(filters).replace(/"/g, '\\"') + `", 
                            rdd_collectors: "` + collector + `") {
                            status
                            error
                            errordesc
                            command
                            createResponse
                        }
                    }`;
             //       console.log(download_events)
                    const res = await API.graphql(graphqlOperation(download_events));
                    if (res.data.createRDDJob) {
                        if (res.data.createRDDJob.status == 'success' ) {
                            this.dataQueued=2
                        } else {
                            this.dataQueued=3
                        }
                    } else {
                        this.dataQueued=3
                    }
            } catch(err) {
                this.dataQueued=3
                console.log(err)
                console.log("An error has occurred")
            }
        },

        searchThrottler: async function (i, concurrentQueries,thisquerytime,window) {
            var abort=false
            var count=99
            var q=true
            var wait=true
            while (wait==true) {
                count=0
                q=false
                for (var j = 0; j < window.length; j++) {
                    if (window[j].running){
                        if (j<i) {q=true}
                        count+=1
                    }
                }
                if (thisquerytime!=this.querytime){abort=true}
                if (abort) {
                    wait=false
                }
                if (count<concurrentQueries){
                    wait=false
                }
                if (q) {
//                    wait = true
                }
                if (wait) {
                    await this.sleep(500)
                }
            }
            return abort
        },

        flipForm: async function () {
            this.showForm = true;
        },
        quickmove(point,event) {
            if (event.length > 0){
                const item = event[0]
                var index=item._index
                var requestedtime = this.ep_labels[index]
                var record=0
                for (var i=0; i<this.ep_value.length; i++) {
                    if (this.ep_labels[i]<requestedtime) {
                        record+=this.ep_value[i]
                    }
                }
                var page=Math.floor(record/this.pagination.rowsPerPage)+1
                this.pagination.page=page
                this.getData()
            }
        },
        getData: async function (){
         //   console.log("getdata "+this.totalResults + " "+this.updatingresults)
            this.loading = true
            if (this.updatingresults == false){
                this.updatingresults=true
                this.updateResultWindow().then(data => {
                    this.loading=true
                    this.searchResults=data.items
                    this.rowsdisplayed=data.rowsPerPage
                    this.windowsize=data.graphpos
                    this.loading = false
                    this.runWindows(this.buckets)
                    this.updatingresults=false
                });
            } else {
     //           console.log("skipping due to already active "+this.updatingresults)
            }
        },
        updateResultWindow: async function () {
            return new Promise((resolve) => {
                const { page, rowsPerPage } = this.pagination            
//                console.log("promise");
                let startrecord=(page-1)*rowsPerPage
                let lastrecord=startrecord+rowsPerPage
                var items=[]
                var row = null
                var counter=0
                var graphpos=[]
                var bucket1=0
                var bucket2=0
                var i=0
                this.buckets = []
                var b_start=-1
                var b_length=-1
                var b_size=0
                var b_end=0
                var window_start=startrecord-500
                var window_end=lastrecord+500
                var bucket_info={}
                var inprogress=false
                if (window_start<0) {
                    window_end-=window_start
                    window_start=0
                    }
//                console.log(this.searchWindows.length)
                for( i = 0; i < this.searchWindowsCount.length; i++) {
                    b_start=-1
                    b_length=-1
                    if (this.searchWindows[i].loading==true){
                        inprogress=true
                    }
                    if (this.searchWindowsCount[i].result != null) {
                        if (this.searchWindowsCount[i].result != 'error') {
                            b_size=this.searchWindowsCount[i].event_count
                            b_end=counter+b_size
                            //console.log(i+" " +window_start+" "+b_end+" ("+b_size+") "+counter)
                            if (window_start<=b_end && b_end>counter) {
                                // find offset from beginning of bucket
                                b_start=window_start-counter
                                if (b_start<0) {b_start=0}
                                if (counter<=window_end) {
                                    // find required length of data from beginning of request
                                    b_length=window_end-counter
                                    if (b_length>b_size) {b_length=b_size}
                                    b_length-=b_start
                                    bucket_info={
                                        "number":i,
                                        "offset":b_start,
                                        "limit":b_length,
                                        "timestartc":this.searchWindowsCount[i].timestamp,
                                        "timestartd":this.searchWindows[i].timestamp
                                    }
                                    this.buckets.push(bucket_info)
                                    this.searchWindows[i].datarequired=true
                                } else {
                                    this.searchWindows[i].datarequired=false
                                    this.searchWindows[i].result=null
                                    this.searchWindows[i].loading=false
                                }
                            } else {
                                this.searchWindows[i].datarequired=false
                                this.searchWindows[i].result=null
                                this.searchWindows[i].loading=false
                            }
                            counter+=b_size
                        }
                    }
                }
                if (inprogress) {
                    this.searchWindowsStatus=1
                } else {
                    this.searchWindowsStatus=0
                }
     //           console.log(counter)
                //console.log(this.buckets)
                counter=0
//                var pushcount=0
//                var state=""
//                var needdata=false
//                pushcount=0
//                state=""
                window_start=0
                window_end=0
                for( i = 0; i < this.searchWindows.length ; i++) {
                    if (this.searchWindows[i].result != null) {
//                        state=""
                        if (this.searchWindows[i].result != 'error') {
                            counter+=this.searchWindows[i].offset
                            for (var j = 0 ; j < this.searchWindows[i].result.length ; j++ ) {
                                row=this.searchWindows[i].result[j]
                                if (counter>=startrecord) {
                                    if (counter<lastrecord){
//                                        state="showing"
                                        if (window_start==0) {window_start=row.time_5min}
                                        if (bucket1==0) {bucket1=i}
                                        window_end=row.time_5min
                                        bucket2=i
                                        items.push(row);
                        //                console.log(row.time_5min)
//                                        pushcount+=1
                                    }
                                }
                                counter+=1
                            }
                        }
//                        console.log(this.searchWindows[i].time + " " + i + " " + state)
                    } else {
//                        console.log(i + " = null")
                        if (this.searchWindowsCount[i].result != null) {
                            counter+=this.searchWindowsCount[i].event_count
                        }
                    }
                }
//                console.log("pushed "+pushcount)
                var stackbar=0
                var lower=0
                var higher=0
                for (i=0; i<this.ep_value.length;i++) {
                    this.bar_highlight[i]=0
                    if (this.ep_labels[i]<=window_start) {
                        lower=i
                    }
                    if (this.ep_labels[i]<=window_end) { 
                        higher=i
                    }
                }
                for (i=lower;i<=higher;i++) {
                    stackbar=(this.maxChartValue*1.1)-this.ep_value[i]
                    this.bar_highlight[i]=stackbar
                }
                this.chartData={
                    labels: this.bar_times,
                    datasets: [
                        {
                            barPercentage:1,
                            categoryPercentage:1,
                            data: this.ep_value,
                            backgroundColor: this.gradientFill,
                            borderColor: "rgba(255,99,132,0.8)",
                        },
                        {
                            barPercentage:1,
                            categoryPercentage:1,
                            data: this.bar_highlight,
                            backgroundColor: "rgba(200,200,200,0.8)",
                            borderColor: "rgba(200,200,200,0.8)",
                        }

                        ]
                    }
                setTimeout(() => {
                    resolve({
                        page,
                        rowsPerPage,
                        items,
                        graphpos,
                    })
                }, 100)
            })
        },
        runSearchSplit: async function () {
            this.options.onClick=this.quickmove
            this.loading=true
            this.showForm = false;
            this.showData = true;
            this.showLoad = true;
            this.allowResearches = false;
            this.rerunMessage = false;
            this.ep_labels=[];
            this.ep_value=[];
            this.searchResults = [];
            this.episodeCache = [];
            this.setFromTime();
            this.setScoreBounds();
            this.totalResults=0;
            var t_from = this.searchForm.time_from
            var t_to = this.searchForm.time_to
            var timewindowsCount = []
            var timewindows = []
            var id = 1
            var dateTime={}
            var part_time=3600
            if (this.querySelect=="Notifications") {
                part_time=3600*24
            }
            var loop_t_from=t_from
            var part_t_from=Math.floor(t_from/part_time)*part_time
            var part_t_to=0
            while ( loop_t_from < t_to ) {
                part_t_from=Math.floor(loop_t_from/part_time)*part_time
                part_t_to=part_t_from+part_time
                loop_t_from=part_t_from
                if (t_from>part_t_from) {
                    part_t_from=t_from
                }
                if (t_to<part_t_to) {
                    part_t_to=t_to
                }
             //   console.log(part_t_from + " -> "+part_t_to)
                dateTime=this.convertEpochtoTimeDate(part_t_from)
                timewindowsCount.push({
                    'id': id,
                    'timestamp': part_t_from,
                    'timeend': part_t_to,
                    'time': dateTime.time,
                    'date': dateTime.date,
                    'running': false,
                    'loading': true,
                    'result': null,
                    'event_count' : 0
                })
                timewindows.push({
                    'id': id,
                    'timestamp': part_t_from,
                    'timeend': part_t_to,
                    'time': dateTime.time,
                    'date': dateTime.date,
                    'n_events': 0,
                    'loading': false,
                    'queued':false,
                    'running':false,
                    'datarequired': false, 
                    'offset': 0,
                    'limit':0,
                    'result': null,
                    'totalcount':0
                })
                this.ep_labels.push(id)
                this.ep_value.push(0)
                loop_t_from += part_time
                id += 1
            }
            //console.log(timewindowsCount)
            this.searchWindowsCount = timewindowsCount
            this.searchWindows = timewindows
            this.runWindowsCount(this.searchWindowsCount)
        },
        runWindows: async function (somebuckets) {
            var nero = []
            var j=0;
            var windowid=0
            this.resError="Waiting for results.... Please wait"
            //this.apicount=0
            for (j = 0 ; j < somebuckets.length ; j++ ) {
                windowid=somebuckets[j].number
                if (somebuckets[j].offset != this.searchWindows[windowid].offset || somebuckets[j].limit != this.searchWindows[windowid].limit) {
                    this.searchWindows[windowid].result = null
                    this.searchWindows[windowid].loading = true
    //                console.log("resetting")
                }
                if (this.searchWindows[windowid].result == null) {
                    this.searchWindowsStatus=1
                    this.searchWindows[windowid].offset = somebuckets[j].offset
                    this.searchWindows[windowid].limit = somebuckets[j].limit
                    if (this.querySelect=="Episodes"){
                        nero.push(this.episodeSearchSplit(this.searchWindows[windowid]))
                    }
                    if (this.querySelect=="Events"){
                        nero.push(this.eventSearchSplit(this.searchWindows[windowid]))
                    }
                    if (this.querySelect=="Notifications"){
                     //   console.log("Calling notifications "+windowid)
                        nero.push(this.notificationsSearchSplit(this.searchWindows[windowid]))
                    }
                } else {
                    nero.push(null)
                }
            }
            for (j = 0 ; j < somebuckets.length ; j++ ) {
                windowid=somebuckets[j].number
                if (nero[j] != null) {
                    this.searchWindows[windowid].result = await nero[j]
                }
            }
        },
        runWindowsCount: async function (timewindowsCount) {
            this.searchWindowsCountStatus=1
            this.searchWindowsCountPercentage=0
            var nero = []
            var j=0;
            this.resError="Finding results..... please wait"
           // console.log("starting counts")
            if (this.querySelect == "Episodes"){
                for (j = 0 ; j < timewindowsCount.length ; j++ ) {
                    await this.sleep(50)
                    nero.push(this.episodeSearchSplitCount(timewindowsCount[j],j))
                }
            }
            if (this.querySelect == "Events"){
             //   console.log("pushing event count requests")
                for (j = 0 ; j < timewindowsCount.length ; j++ ) {
                    await this.sleep(50)
                    nero.push(this.eventSearchSplitCount(timewindowsCount[j],j))
                }
            }
            if (this.querySelect == "Notifications"){
             //   console.log("pushing event count requests")
                for (j = 0 ; j < timewindowsCount.length ; j++ ) {
                    await this.sleep(50)
                    nero.push(this.notificationsSearchSplitCount(timewindowsCount[j],j))
                }
            }
        },
        
        ResultCount: async function () {
            var total=0
            var c=0
            var c_sum=0
            var t=0
            var j=0
            var k=0
            var s=0
            var values=[]
            var times=[]
            var max=0
            var finished=0
            var dohours=true
            var starttime=0
            var finishtime=0
            var timestamp=0
            var scale=12
            var c_avg=0
            var err_count=0
            var totalcounts=this.searchWindowsCount.length
            var barcount=100

            starttime=this.searchForm.time_from
            finishtime=this.searchForm.time_to
            var five_min_windows=Math.floor((finishtime-starttime)/300)

//            if (this.querySelect=="Notifications") {
//                five_min_windows=totalcounts*12*24
//            }
            if (five_min_windows>barcount){
                scale = five_min_windows/barcount
                c=new Array(barcount)
                t=new Array(barcount)
            } else {
                scale=1
                barcount=five_min_windows
                c=new Array(barcount+1)
                t=new Array(barcount+1)
            }
            c_sum=0
            var c_pos=0
            var t_count=0
            var sw_count=0
            var record_time=0

            for ( i=0 ; i<c.length; i++){
                timestamp=starttime+(i*five_min_windows*300/barcount)
                c[i]=0
                t[i]=timestamp
            }
            for( var i = 0; i < totalcounts ; i++) {
                sw_count=0
                if (this.searchWindowsCount[i].result != null) {
                    finished+=1
                    if (this.searchWindowsCount[i].loading) {
                        this.searchWindowsCount[i].loading=false
                    }
                    for (j=0;j<this.searchWindowsCount[i].result.length; j++) {
                        record_time=this.searchWindowsCount[i].result[j].time_5min
                        t_count=record_time-starttime
                        t_count=t_count/300
                        t_count=Math.floor(t_count)
                        c_pos=Math.floor(t_count/scale)
                        c_sum=c[c_pos]
                        c_sum+=this.searchWindowsCount[i].result[j].event_count
                        sw_count+=this.searchWindowsCount[i].result[j].event_count
                        c[c_pos]=c_sum
//                        t[c_pos]=record_time
                    }
                }
                this.searchWindowsCount[i].event_count=sw_count
                this.searchWindows[i].totalcount=sw_count
                total+=sw_count
            }
            max=0
            for ( i=0 ; i<c.length; i++){
//                timestamp=starttime+(i*five_min_windows*300/100)
                times.push(t[i])
                values.push(c[i])
                if (c[i]>max) {
                    max=c[i]
                }
            }
          //  console.log(times)
         //   console.log(values)
//            console.log(c)
//                        this.searchWindowsCount[i].event_count=c_sum
//                        this.searchWindows[i].totalcount=c_sum
//                        times.push(t[k])
//                        values.push(c_avg)


//            var is_notifications=false
//            var k_window=12
//            if (totalcounts<96) {
//                dohours=false
//                scale=4
//                if (totalcounts<48) {
//                    scale=2
//                }
//                if (totalcounts<24) {
//                    scale=1
//                }
//            }
//            if (this.querySelect=="Notifications") {
//                is_notifications=true
//                k_window=24*12
//            }
//            for( var i = 0; i < totalcounts ; i++) { // 
//                c=0
//                c_sum=0
//                if (dohours) {
//                    c=0
//                   t=0
//                    if (is_notifications) {
//                        c=new Array(24)
//                        t=new Array(24)
//                    }
//                } else {
//                    c=new Array(k_window)
//                    t=new Array(k_window)
//                }
//               if (this.searchWindowsCount[i].result != 'error') {
//                    starttime=this.searchWindowsCount[i].timestamp
//                    if (dohours && !is_notifications) {
//                        t=starttime
//                    } else {
//                        for (k=0;k<k_window;k++){
//                            timestamp=starttime+(k*300)
//                            t[k]=timestamp
//                        }
//                    }
//                    if (this.searchWindowsCount[i].result != null) {
//                        if (this.searchWindowsCount[i].loading) {
//                            this.searchWindowsCount[i].loading=false
//                        }
//                        finished+=1
//                        if (dohours && !is_notifications) {
//                            for (j=0;j<this.searchWindowsCount[i].result.length; j++) {
//                                c_sum+=this.searchWindowsCount[i].result[j].event_count                        
//                            }
//                        } else {
//                            console.log(this.searchWindowsCount)
//                            starttime=this.searchWindowsCount[i].timestamp
//                            for (k=0;k<k_window;k++){
//                                timestamp=starttime+(k*300)
//                                for (j=0;j<this.searchWindowsCount[i].result.length; j++) {
//                                    if (this.searchWindowsCount[i].result[j].time_5min==timestamp) {
 //                                       c[k]=this.searchWindowsCount[i].result[j].event_count
 //                                       c_sum+=this.searchWindowsCount[i].result[j].event_count
 //                                   }
 //                               }
 //                           }
//                            console.log(c)
//                        }
//                        this.searchWindowsCount[i].event_count=c_sum
//                        this.searchWindows[i].totalcount=c_sum
//                    }
//                } else {
//                    this.searchWindowsCount[i].result = null;
//                    this.searchWindowsCount[i].loading = true;
//                    finished+=1
//                    this.resError="Loading "+finished+" of "+totalcounts
//                    err_count+=1
//                }
//                if (dohours && !is_notifications){
//                    values.push(c_sum)
//                    times.push(t)
//                    if (c_sum>max){
//                        max=c_sum
//                    }
//                } else {
//                    k=0
//                    while (k<k_window) {
//                        c_avg=0
//                        times.push(t[k])
//                        for (s=0;s<scale;s++){
//                            c_avg+=c[k]
//                            k+=1
//                        }
//                        values.push(c_avg)
//                        c_avg=c_avg/scale
//                        if (c_avg>max){
//                            max=c_avg
//                        }
//                    }
//                }
//                total+=c_sum
//            }
//            console.log(this.searchWindowsCount)
//            console.log(values)
//            console.log(times)
//            console.log("Loading "+finished+" of "+totalcounts)
//            var min=max/20
//            if (max>50){
//                min=(max/50)
//            }
        //    console.log(max)
            var now=new Date()
            var diff = now-this.drawtime
////            this.ep_value=[]
            if (diff>1000 || this.apicount<1){
                this.barchartdata={}
                this.ep_value=[]
                this.ep_labels=[]
                this.bar_times=[]
                this.bar_highlight=[]
                this.ticktimes=[]
                this.ticklabels=[]

                this.drawtime=now
                var formattedTime
                this.maxChartValue=max

                this.options.onClick=this.quickmove

                for (i=0; i<values.length; i++){
                    this.ep_value.push(values[i])
                    this.ep_labels.push(times[i])

                    if (times[i]==0) {
                        formattedTime = "--"
                    } else {
                        formattedTime = moment.unix(times[i]).tz(this.tz).format("MMM-DD HH:mm");
                    }
                    this.bar_times.push(formattedTime)
                    this.bar_highlight.push(0) 
                }
                    this.gradientFill = this.$refs.chart.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 150)
                    this.gradientFill.addColorStop(0, 'red')
                    this.gradientFill.addColorStop(1, '#3900aa');

                    this.chartData={
                    labels: this.bar_times,
                    datasets: [
                        {
                            barPercentage:1,
                            categoryPercentage:1,
                            data: this.ep_value,
                            backgroundColor: this.gradientFill, //"rgba(255,99,132,0.8)",
                            borderColor: "rgba(255,99,132,0.8)",
                        },
                        {
                            barPercentage:1,
                            categoryPercentage:1,
                            data: this.bar_highlight,
                            backgroundColor: "rgba(200,200,200,0.8)",
                            borderColor: "rgba(200,200,200,0.8)",
                        }
                    ]
                }
            }
            this.totalResults=total
            this.searchWindowsCountPercentage = Math.floor(100*finished/this.searchWindowsCount.length)
        //    console.log(this.searchWindowsCountPercentage)
        //    console.log("finished = "+finished)
        //    console.log("len = "+this.searchWindowsCount.length)
            if (finished==this.searchWindowsCount.length) {
        //        console.log("finished")
                this.getData()
                this.showLoad = true;
                if (err_count==0) {
                    this.searchWindowsCountStatus=0
                } else {
                    this.searchWindowsCountStatus=2
                }
            }
//            console.log("finished "+finished+" out of "+this.searchWindowsCount.length+" min="+min+" max="+max)
//            console.log(diff)
        },

        downloadEpisodes: async function() {
            try {
                    var t_from = this.searchForm.time_from
                    var t_to = this.searchForm.time_to
                    var collector="episodes"
                    this.dataQueued=1
                    var filters = {
                        "prefix":this.searchForm.prefix, 
                        "asn":this.searchForm.asn,
                        "path":this.searchForm.asn,
                        "h_greater_than": this.searchForm.h_greater_than,
                        "i_greater_than": this.searchForm.i_greater_than,
                        "h_less_than": this.searchForm.h_less_than,
                        "i_less_than": this.searchForm.i_less_than,
                        "order_by": this.searchForm.order_by_episode + "//" + this.searchForm.order_by_episode2,
                        "exclude_path_change": !this.searchForm.exclude_path_change,
                        "exclude_first_seen": !this.searchForm.exclude_first_seen
                    };
                    var download_episodes=`mutation createRDDJob {
                        createRDDJob(rdd_usertype:"user",
                            rdd_start:"` + t_from + `",
                            rdd_finish:"` + t_to + `",
                            rdd_filters: "` + JSON.stringify(filters).replace(/"/g, '\\"') + `", 
                            rdd_collectors: "` + collector + `") {
                            status
                            error
                            errordesc
                            command
                            createResponse
                        }
                    }`;
            //        console.log(download_episodes)
                    const res = await API.graphql(graphqlOperation(download_episodes));
                    if (res.data.createRDDJob) {
                        if (res.data.createRDDJob.status == 'success' ) {
                            this.dataQueued=2
                        } else {
                            this.dataQueued=3
                        }
                    } else {
                        this.dataQueued=3
                    }
            } catch(err) {
                this.dataQueued=3
                console.log(err)
                console.log("An error has occurred")
            }
        },

        episodeSearchSplit: async function (t) {
            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }
            var pre2search = this.searchForm.prefix;
            try {
                var getSearchEpisodesQuery = `query getSearchEpisodes1Hour { getSearchEpisodes1Hour(
                asn: "`+ a + `",
                prefix: "` + pre2search + `",
                time_from: `+ t.timestamp + `,
                h_greater_than: `+ this.searchForm.h_greater_than + `,
                i_greater_than: `+ this.searchForm.i_greater_than + `,
                h_less_than: `+ this.searchForm.h_less_than + `,
                i_less_than: `+ this.searchForm.i_less_than + `,
                order_by: "`+ this.searchForm.order_by_episode + `//` + this.searchForm.order_by_episode2 + `",
                exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                offset: `+t.offset+`,
                limit: `+t.limit+` ) { 
                                    prefix 
                                    origin_asn_new
                                    origin_asn_old
                                    time_5min
                                    human_time
                                    hijack_score_mean
                                    impact_score_mean
                                    event_count
                                    non_direct_prefix
                                    } 
                                }`;
                //console.log("Episodes QUERY")
                //console.log(getSearchEpisodesQuery);
                const episodeData = await API.graphql(graphqlOperation(getSearchEpisodesQuery));
                var event=false;
                if (!episodeData) {
                    event = false;
                } else {
                    event = episodeData.data.getSearchEpisodes1Hour;
                    //console.log("got result!!!" + event.length + " "+t.timestamp)
                    //console.log(event);
                    t.loading=false;
                }
            } catch(err) {
                console.log(err)
                console.log(err.errors[0].message)
                console.log("An error has occurred")
                return 'error'
            }

            if (!event) {
                this.loading = false
                return []
            } else {
                if (event.length == 0 || event === undefined || !event) {
                    this.loading = false
                    return []
                } else {
                    var urldata = window.location.origin + "/#/alertFromTop10/"
                    for (var n = 0; n < event.length ; n++ ) {
                        event[n].alert_url = urldata + event[n].prefix.replace("/", "%2F") + "~" + event[n].origin_asn_old + "~" + event[n].origin_asn_new + "~" + event[n].time_5min
                        
                        var dateTime = this.convertEpochtoTimeDate(event[n].time_5min);
                        event[n].interval_start  = dateTime

                        event[n].episode_type = this.getEpisodeType(event[n])
                    }
                    return event;
                }
            }

        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        episodeSearchSplitCount: async function (t,i) {
            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }
            var retrycount=0
            var event=null
            var thistime=this.querytime
            var abort=false
            var pre2search = this.searchForm.prefix;
            abort=await this.searchThrottler(i, this.concurrentEventQueries,thistime,this.searchWindowsCount)   
            t.running=true
            t.loading=true
            while (retrycount<this.searchRetries && event==null && abort==false){
                if (!abort) {
                    try {
                        var getSearchEpisodesQueryCount = `query getSearchEpisodes1HourCount { getSearchEpisodes1HourCount(
                        asn: "`+ a + `",
                        prefix: "` + pre2search + `",
                        time_from: `+ t.timestamp + `,
                        h_greater_than: `+ this.searchForm.h_greater_than + `,
                        i_greater_than: `+ this.searchForm.i_greater_than + `,
                        h_less_than: `+ this.searchForm.h_less_than + `,
                        i_less_than: `+ this.searchForm.i_less_than + `,
                        order_by: "`+ this.searchForm.order_by_episode + `//` + this.searchForm.order_by_episode2 + `",
                        exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                        exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                        offset: 0,
                        limit: 1000 ) { 
                                        time_5min,
                                        event_count 
                                        } 
                                    }`;
                    // console.log(getSearchEpisodesQueryCount);
                    //    console.log("starting query "+i)
                        const episodeDataCount = await API.graphql(graphqlOperation(getSearchEpisodesQueryCount));
                        event=false;
                        if (!episodeDataCount) {
                            event = false;
                        } else {
                            event = episodeDataCount.data.getSearchEpisodes1HourCount;
                        }
                    } catch(err) {
                        console.log(err);
                        console.log(err.errors[0].message);
                        console.log("An error has occurred");
                    }
                }
            }
            if (thistime==this.querytime){
                if (!event) {
                    this.searchWindowsCount[i].result=[{"time_5min":0,"event_count":-1},]
                } else {
                    this.searchWindowsCount[i].result=event
                }
            }
            t.running=false
        },

        downloadNotifications: async function() {
            try {
                    var t_from = this.searchForm.time_from
                    var t_to = this.searchForm.time_to
                    var collector="notifications"
                    this.dataQueued=1
                    var filters = {
                        "prefix":this.searchForm.prefix, 
                        "asn":this.searchForm.asn,
                        "path":this.searchForm.asn,
                        "h_greater_than": this.searchForm.h_greater_than,
                        "i_greater_than": this.searchForm.i_greater_than,
                        "h_less_than": this.searchForm.h_less_than,
                        "i_less_than": this.searchForm.i_less_than,
                        "order_by": this.searchForm.order_by_episode + "//" + this.searchForm.order_by_episode2,
                        "exclude_path_change": !this.searchForm.exclude_path_change,
                        "exclude_first_seen": !this.searchForm.exclude_first_seen
                    };
                    var download_episodes=`mutation createRDDJob {
                        createRDDJob(rdd_usertype:"user",
                            rdd_start:"` + t_from + `",
                            rdd_finish:"` + t_to + `",
                            rdd_filters: "` + JSON.stringify(filters).replace(/"/g, '\\"') + `", 
                            rdd_collectors: "` + collector + `") {
                            status
                            error
                            errordesc
                            command
                            createResponse
                        }
                    }`;
            //        console.log(download_episodes)
                    const res = await API.graphql(graphqlOperation(download_episodes));
                    if (res.data.createRDDJob) {
                        if (res.data.createRDDJob.status == 'success' ) {
                            this.dataQueued=2
                        } else {
                            this.dataQueued=3
                        }
                    } else {
                        this.dataQueued=3
                    }
            } catch(err) {
                this.dataQueued=3
                console.log(err)
                console.log("An error has occurred")
            }
        },

        notificationsSearchSplitCount: async function (t,i) {
            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }
         //   console.log("notif count")
            var retrycount=0
            var notificationCount=null
            var thistime=this.querytime
            var abort=false
            var pre2search = this.searchForm.prefix;
            abort=await this.searchThrottler(i, this.concurrentEventQueries,thistime,this.searchWindowsCount)   
            t.running=true
            t.loading=true
            while (retrycount<this.searchRetries && notificationCount==null && abort==false){
                if (!abort) {
                    try {
                        var getSearchNotificationsCount = `query getSearchNotificationsCount { getSearchNotificationsCount(
                        asn: "`+ a + `",
                        prefix: "`+ pre2search + `",
                        time_from: `+ t.timestamp + `,
                        time_to: `+ t.timeend + `,
                        h_greater_than: `+ this.searchForm.h_greater_than + `,
                        i_greater_than: `+ this.searchForm.i_greater_than + `,
                        h_less_than: `+ this.searchForm.h_less_than + `,
                        i_less_than: `+ this.searchForm.i_less_than + `,
                        order_by: "`+ this.searchForm.order_by_notification + `//` + this.searchForm.order_by_notification2 + `",
                        exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                        exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                        organisation: "` + this.organisation + `"
                        offset: 0,
                        limit: 100 ) { 
                                        time_5min,
                                        event_count 
                                        } 
                                    }`;
//                     console.log(getSearchNotificationsCount );
                    //    console.log("starting query "+i)
                        const notificationDataCount = await API.graphql(graphqlOperation(getSearchNotificationsCount));
//                        console.log(notificationDataCount.data.getSearchNotificationsCount)
                        notificationCount=false;
                        if (!notificationDataCount) {
                            notificationCount = false;
                        } else {
                            notificationCount = notificationDataCount.data.getSearchNotificationsCount;
                        //    console.log(notificationCount)
                      //      if (notificationCount.length>0) {
                      //          console.log("got result "+i+" " + notificationCount[0].event_count + " "+notificationCount[0].time_5min)
                      //      } else {
                      //          console.log("got result => zero")
                      //      }
                        }
                    } catch(err) {
                        console.log(err);
                        console.log(err.errors[0].message);
                        console.log("An error has occurred");
                    }
                }
            }
        //    console.log("end?")
            if (thistime==this.querytime){
                if (!notificationCount) {
                    this.searchWindowsCount[i].result=[{"time_5min":0,"event_count":-1},]
                } else {
                    this.searchWindowsCount[i].result=notificationCount
            //        console.log("recorded result")
                }
            }
            t.running=false
        },




    notificationsSearchSplit: async function (t) {
//            this.showData = false;
//            this.showLoad = true;
//            this.setFromTime();
//            this.setScoreBounds();

            var a;
            if (this.searchForm.asn == '') {
                a = 0;
            } else {
                a = this.searchForm.asn;
            }

            var pre2search = this.searchForm.prefix;

            try {
                var getSearchNotificationsQuery = `query getSearchNotificationsQuery { getSearchNotifications(
                    asn: "`+ a + `",
                    prefix: "`+ pre2search + `",
                    time_from: `+ t.timestamp + `,
                    time_to: `+ t.timeend + `,
                    h_greater_than: `+ this.searchForm.h_greater_than + `,
                    i_greater_than: `+ this.searchForm.i_greater_than + `,
                    h_less_than: `+ this.searchForm.h_less_than + `,
                    i_less_than: `+ this.searchForm.i_less_than + `,
                    order_by: "`+ this.searchForm.order_by_notification + `//` + this.searchForm.order_by_notification2 + `",
                    exclude_path_change: `+ !this.searchForm.exclude_path_change + `,
                    exclude_first_seen: `+ !this.searchForm.exclude_first_seen + `,
                    offset: `+t.offset+`,
                    limit: `+t.limit+`,
                    organisation: "` + this.organisation + `"
                    ) { 
                        prefix 
                        origin_asn_new
                        origin_asn_old
                        time_5min
                        human_time
                        hijack_score_mean
                        impact_score_mean
                        event_count
                        asn_of_interest
                        validation
                        email_count
                        asn_class
                        human_time
                        non_direct_prefix
                        controlled_prefix
                    } 
                }`;
        //    console.log(getSearchNotificationsQuery);
            const notificationData = await API.graphql(graphqlOperation(getSearchNotificationsQuery));
        //    console.log(notificationData);
            var notifications=false;
            if (!notificationData) {
                notifications = false;
            } else {
                notifications = notificationData.data.getSearchNotifications;
                t.loading=false;
        //       console.log(notifications);
            }
            } catch(err) {
                console.log(err)
                console.log(err.errors[0].message)
                console.log("An error has occurred")
                return 'error'
            //console.log("An error has occurred");
            //console.log(err)
//            this.$store.state.lastSearch = false;
//            this.erColor = "red";
//            this.resError = err.errors[0].message;
//            this.notifications = [];
//            this.showData = true;
 //           this.showLoad = false;
            }
            if (!notifications) {
                this.loading = false
                return []
//                this.notifications = [];
            } else {
                if (notifications.length == 0 || notifications === undefined || !notifications) {
                    this.loading=false
                    return []
//                    this.notifications = [];
//                    this.erColor = "success";
//                    this.resError = "No notifications found.";
                } else {
//                    this.notifications = notification;
                    for (var n = 0 ; n < notifications.length ; n ++ ) {
                        var dateTime = this.convertEpochtoTimeDate(notifications[n].time_5min);
                        notifications[n].interval_start  = dateTime
                        if (notifications[n].asn_of_interest == '99999999999') {
                            notifications[n].asn_of_interest = 'Restricted Prefix'
                        }
                        if (notifications[n].non_direct_prefix == 'null') {
                            notifications[n].non_direct_prefix = 'N/A'
                        }
                        notifications[n].alert_type = this.getAlertType(notifications[n])
                        // we set the asn of interest to the restricted prefix for display purposes
                        if (notifications[n].controlled_prefix != 'null' && notifications[n].controlled_prefix) {
                            notifications[n].asn_of_interest = notifications[n].controlled_prefix
                        }
                    }
//                    console.log(notifications)
                    return notifications
                }     
            }     
//            this.showData = true;
//            this.showLoad = false;
//            this.showForm = false;

        },
        getAlertType: function (alert) {
            if (alert.asn_of_interest == 'Restricted Prefix') {
                return 'Restricted Prefix'
            } else if (alert.origin_asn_old == '0' || alert.origin_asn_old == 0) {
                return 'First Seen Prefix'
            } else if (alert.origin_asn_new == alert.origin_asn_old) {
                return 'Path Change'
            } else {
                if (alert.non_direct_prefix == 'N/A' || alert.non_direct_prefix == null) {
                    return 'Ownership Assertion'
                } else {
                    var nd_cidr = parseInt(alert.non_direct_prefix.split("/")[1])
                    var cidr = parseInt(alert.prefix.split("/")[1])
                    if (nd_cidr > cidr) {
                        return 'Super-ownership Assertion'
                    } else {
                        return 'Sub-ownership Assertion'
                    }

                }
            }
        },
        getEpisodeType: function (episode) {
            if (episode.origin_asn_old == '0' || episode.origin_asn_old == 0) {
                return 'First Seen Prefix'
            } else if (episode.origin_asn_new == episode.origin_asn_old) {
                return 'Path Change'
            } else {
                if (episode.non_direct_prefix == 'N/A' || !episode.non_direct_prefix) {
                    return 'Ownership Assertion'
                } else {
                    var nd_cidr = parseInt(episode.non_direct_prefix.split("/")[1])
                    var cidr = parseInt(episode.prefix.split("/")[1])
                    if (nd_cidr > cidr) {
                        return 'Super-ownership Assertion'
                    } else {
                        return 'Sub-ownership Assertion'
                    }

                }
            }
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
//                var d = new Date( epochTime *1000);

//                var day = ("0" + d.getUTCDate()).slice(-2);
//                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
//                var year = d.getUTCFullYear()
//                var dateFormatted = day + "/" + month + "/" + year
//                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

                var dateFormatted = moment.unix(epochTime).tz(this.tz).format('DD/MM/YYYY')
                var timeFormatted = moment.unix(epochTime).tz(this.tz).format('HH:mm')
                var dateTime  = {"date": dateFormatted, "time": timeFormatted}

                return dateTime
            }
            catch(err) {
                console.log(err)
            }

        }
    },
    watch: {
        pagination: {
            handler () {
                //console.log("handler")
                //console.log(this.querySelect)
                this.getData()
            },
            deep: true
        },
        searchWindowsCount: {
            handler: function (val) {
                if (val) {
                    for ( var i = 0 ; i < val.length ; i ++ ) {
                        if (val[i] != null ) {
                            if (val[i].result != null) {
                                if (val[i].loading == true) {
                                    this.ResultCount();
                                }
                            }
                        }
                    }
                }
            },
            deep: true  
        },
        searchWindows: {
            handler: function (val) {
                if (val) {
                    var alldone = 1
                    var i=0
                    if ( this.allowResearches ) {
                        for ( i = 0 ; i < val.length ; i ++ ) {
                            if ( i == val.length - 1 && alldone == 1) {
                                if (this.querySelect == 'Notifications') {
                                    //this.runNotificationSearch();
                                }                                
                            }
                        }
                    }
                    if (this.querySelect == 'Episodes' || this.querySelect == 'Events' || this.querySelect=='Notifications') {
                        var bucketswithresults=0
                        if (this.buckets.length>0) {
                            for (i=0;i<this.buckets.length;i++ ) {
                                if (this.buckets[i] != null) {
                                    if (this.searchWindows[this.buckets[i].number].result != null) {
                                        bucketswithresults+=1
                                    }
                                }
                            }
                //            console.log(bucketswithresults)
                            if (bucketswithresults==this.buckets.length){
                //                console.log("getting data")
                                    this.getData()
                            }
                        }
                    }
                }
            },
            deep: true  
        },
    }
}

</script>


<style scoped>

    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

.chart-container {
    z-index: 1;
    margin: auto; 
    position: relative;
    width: 100%;
    height: 200px;
    max-height: 200px;
}
</style>
